var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48111",
    "data-name": "Group 48111",
    transform: "translate(-18902 -4472.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1195",
    "data-name": "Ellipse 1195",
    transform: "translate(18902 4472.564)",
    fill: "none",
    stroke: "#f08f1a",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 33.5,
    rx: 32.5,
    ry: 33.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 33.5,
    rx: 29,
    ry: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-tags",
    "data-name": "Icon awesome-tags",
    d: "M7.145,11.364,17.8.707A2.414,2.414,0,0,1,19.509,0H29.775A2.414,2.414,0,0,1,32.19,2.414V12.681a2.414,2.414,0,0,1-.707,1.707L20.826,25.045a2.414,2.414,0,0,1-3.414,0L7.145,14.778a2.414,2.414,0,0,1,0-3.414ZM26.556,8.047a2.414,2.414,0,1,0-2.414-2.414A2.414,2.414,0,0,0,26.556,8.047ZM.707,14.778,10.973,25.045a2.414,2.414,0,0,0,3.414,0l.018-.018L5.651,16.272a4.527,4.527,0,0,1,0-6.4L15.522,0h-2.45a2.414,2.414,0,0,0-1.707.707L.707,11.364a2.414,2.414,0,0,0,0,3.414Z",
    transform: "translate(18918.402 4493.188)",
    fill: "#f08f1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerPackage);
export default __webpack_public_path__ + "static/media/PartnerPackage.51fcd0ad51e824e0162d03edd6e24c51.svg";
export { ForwardRef as ReactComponent };